export enum DeleteTypes {
  DELETE_OUTPUT_LIST= "DeleteOutputList",
  DELETE_BAND= "DeleteBand",
  DELETE_OUTPUT_MAP_LIST= "DeleteOutputMapList",
}
